import { render } from "./pozitive-uplift.vue?vue&type=template&id=f8988e82"
import script from "./pozitive-uplift.vue?vue&type=script&lang=js"
export * from "./pozitive-uplift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__